import { h, Component } from 'preact';
import { Link } from 'preact-router/match';
import CartWrapper from '../shpfybtn/cartWrapper'
import Image from 'react-lazy-image';


export default class Header extends Component {
	render() {
		const { url = '', goToMerch } = this.props
		const isShop = url.includes('shop') || url.includes('collection')
		const isMusic = url.includes('/#')
		const isShows = url.includes('shows')
		return (
			<header>
			
			
				<div class="cart" >
					<CartWrapper url={url} goToMerch={goToMerch} />
				</div>
			

<div class="project_contain contain">
<div class="title_line"><Link  class="left" href="/"><img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/212585/lugzKS.png"/></Link></div>


</div>
<div class="clearfix"></div>
			</header>
		);
	}
}



// WEBPACK FOOTER //
// ./components/header/index.js